import type { DirectiveBinding } from 'vue'

export default {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    const myEl = el as HTMLElement & { clickOutsideEvent: (event: MouseEvent | Event) => void }

    myEl.clickOutsideEvent = function (event: MouseEvent | Event) {
      // Check if the clicked element is neither the element
      // to which the directive is applied nor its child
      if (!(el === event.target || el.contains(event.target as Node))) {
        // Invoke the provided method
        binding.value(event)
      }
    }
    document.addEventListener('click', myEl.clickOutsideEvent)
  },
  unmounted(el: HTMLElement) {
    // Remove the event listener when the bound element is unmounted
    const myEl = el as HTMLElement & { clickOutsideEvent: (event: MouseEvent | Event) => void }
    document.removeEventListener('click', myEl.clickOutsideEvent)
  },
}
